'use client'
import { isEmbeddedConnector } from '@dynamic-labs/wallet-connector-core';
import { isMobile } from '@dynamic-labs/utils';
import { getWalletBookWallet } from '@dynamic-labs/wallet-book';
import { handleMobileWalletFilter } from '../handleMobileWalletFilter/handleMobileWalletFilter.js';

const filterWalletsForPlatform = (walletBook, wallets) => wallets.filter((wallet) => {
    const metadata = getWalletBookWallet(walletBook, wallet.key, wallet.walletFallback);
    if (wallet.isInstalledOnBrowser()) {
        return true;
    }
    else if (isEmbeddedConnector(wallet)) {
        return true;
    }
    else if (metadata.showOnlyIfInstalled) {
        return false;
    }
    else if (!isMobile()) {
        return true;
    }
    else {
        return handleMobileWalletFilter(walletBook, wallet.key, metadata);
    }
});

export { filterWalletsForPlatform };
